<template>
    <div class="socials">
        <a>
            <img :src="require('@/assets/img/youtube.svg')" alt="youtube" />
        </a>
        <a>
            <img :src="require('@/assets/img/twitter.svg')" alt="twitter">
        </a>
        <a>
            <img :src="require('@/assets/img/fb.svg')" alt="facebook">
        </a>
        <a>
            <img :src="require('@/assets/img/instagram.svg')" alt="instagram">
        </a>
    </div>
</template>

<script>
    export default {
        name: "SocialButton"
    };
</script>

<style scoped lang="scss">
    .socials {
        display: flex;
        align-items: baseline;
        a:not(:last-child) {
            margin-right: 32px;
            cursor: pointer;
        }
    }
</style>
